export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./regEvent.vue?vue&type=template&id=44684778&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/regEvent.vue?vue&type=template&id=44684778&
// module id = 1328
// module chunks = 0